import ImportHelper from './import.helper'

const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/images/GeneralView/", true, /\.webp/)); }
const Porteria = () => { return ImportHelper.importAll(require.context("../assets/images/Porteria/", true, /\.webp/)); }
const Piscina = () => { return ImportHelper.importAll(require.context("../assets/images/Piscina/", true, /\.webp/)); }
const TPCentral = () => { return ImportHelper.importAll(require.context("../assets/images/TP_Central/", true, /\.webp/)); }
const TPDerecha = () => { return ImportHelper.importAll(require.context("../assets/images/TP_Derecha/", true, /\.webp/)); }
const TPIzquierda = () => { return ImportHelper.importAll(require.context("../assets/images/TP_Izquierda/", true, /\.webp/)); }
const TGCentral = () => { return ImportHelper.importAll(require.context("../assets/images/TG_Central/", true, /\.webp/)); }
const TGDerecha = () => { return ImportHelper.importAll(require.context("../assets/images/TG_Derecha/", true, /\.webp/)); }
const TGIzquierda = () => { return ImportHelper.importAll(require.context("../assets/images/TG_Izquierda/", true, /\.webp/)); }

export const ContextLoader = {
    "General View": GeneralView,
    "Portería": Porteria,
    "Piscina": Piscina,
    "Torre 1": TPDerecha,
    "Torre 2":TPCentral,
    "Torre 3": TPIzquierda,
    "Torre 4": TPDerecha,
    "Torre 5":TPCentral,
    "Torre 6": TPIzquierda,
    "Torre 7": TPIzquierda,
    "Torre 8":TPCentral,
    "Torre 9": TPDerecha,
    "Torre 10": TPDerecha,
    "Torre 11":TPCentral,
    "Torre 12": TGIzquierda,
    "Torre 13": TPDerecha,
    "Torre 14":TPCentral,
    "Torre 15": TPIzquierda,
    "Torre 16": TPIzquierda,
    "Torre 17":TPCentral,
    "Torre 18": TGIzquierda,
    "Torre 19": TPDerecha,
    "Torre 20": TPIzquierda,
    "Torre 21": TGDerecha,
    "Torre 22":TGCentral,
    "Torre 23": TGIzquierda,
    "Torre 24": TGIzquierda,
    "Torre 25":TGCentral,
    "Torre 26": TGDerecha,
    "Torre 27": TGIzquierda,
    "Torre 28": TGDerecha,
    "Torre 29": TGIzquierda,
    "Torre 30": TGDerecha,
}
